var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('responsible-list',{attrs:{"users":_vm.item.users,"item":_vm.item,"endpoint":"api/user/responsibles/task"}})}
var staticRenderFns = []

export { render, staticRenderFns }